import { mergeIconColorVars as e } from "../icon-props.js";
import { jsx as t } from "react/jsx-runtime";
//#region src/icons/chevron-left.tsx
function n({ colors: n, style: r, ...i }) {
	return /* @__PURE__ */ t("svg", {
		viewBox: "0 0 24 24",
		fill: "none",
		"aria-hidden": "true",
		focusable: "false",
		xmlns: "http://www.w3.org/2000/svg",
		style: {
			...e(n),
			...r
		},
		...i,
		children: /* @__PURE__ */ t("path", {
			d: "M14.293 5.29295C14.6835 4.90243 15.3166 4.90243 15.7071 5.29295C16.0976 5.68348 16.0976 6.31649 15.7071 6.70702L10.4141 12L15.7071 17.293L15.7754 17.3691C16.0958 17.7619 16.0732 18.3409 15.7071 18.707C15.341 19.0731 14.762 19.0957 14.3692 18.7754L14.293 18.707L8.29302 12.707C7.90249 12.3165 7.90249 11.6835 8.29302 11.293L14.293 5.29295Z",
			fill: "var(--icon-color-primary, currentColor)"
		})
	});
}
//#endregion
export { n as ChevronLeftIcon };
